export default __webpack_public_path__ + "static/pyxel-home-sec-5-8b0c4b97f52fd1bf330cea3c9fc96011.png";